//@flow
import React from 'react';
import { filter, flatten, groupBy } from 'lodash';
import { StringUtil } from 'utils/StringUtil';

const getRentals = state => {
  return state.rentals.rentals;
};

const getRentalLoading = state => {
  return state.rentals.loading.rentals;
};

const getRentalError = state => {
  return state.rentals.error.rentals;
};

const getRentalFeature = state => {
  return state.rentals.rentalFeature;
};

const getRentalFeatureError = state => {
  return state.rentals.loading.rentalFeature;
};

const getRentalFeatureLoading = state => {
  return state.rentals.error.rentalFeature;
};

const getRentalDetailBannerLoading = state => {
  return state.rentals.loading.banner;
};

const getRentalDetailBanner = state => {
  let bannerData = {};
  const rentalHome = state.rentals.banner && state.rentals.banner.home;
  const mediaPath = state.rentals.banner && state.rentals.banner.mediaPath;
  if (!rentalHome || rentalHome.length === 0) {
    return [];
  }

  rentalHome.map(data => {
    bannerData = {
      id: data.id,
      annual_rent_increase: data.annual_rent_increase,
      availability: data.availability,
      currently: data.currently,
      deposit: data.deposit,
      max_rent_duration: data.max_rent_duration,
      property_feature_image: `${mediaPath.web}/${data.property_feature_image}`,
      property_feature_mobile_image: `${mediaPath.mobile}/${data.property_feature_mobile_image}`,
      property_heading: data.property_heading,
      property_tag_word: data.property_tag_word,
      rental_home_brochure: data.rental_home_brochure,
      rental_image: `${mediaPath.web}/${data.rental_image}`,
      rental_mobile_image: `${mediaPath.mobile}/${data.rental_mobile_image}`,
      rental_price: data.rental_price,
      vimeo_link: data.vimeo_link,
      title: data.title,
      reference_no: data.reference_no,
      banner_video: data.vimeo_link,
      image: `${mediaPath.web}/${data.image}`,
      mobile_image: `${mediaPath.mobile}/${data.mobile_image}`,
      thumbnail: `${mediaPath.thumbnail}/${data.image}`,
      guest: data.no_of_guest,
      project_name:
        data.project &&
        data.project.project_details &&
        data.project.project_details[0] &&
        data.project.project_details[0].project_name,
      location: StringUtil.checkBoolean(data.is_completed_project)
        ? `${data.completed_project &&
            data.completed_project.area &&
            data.completed_project.area.area_name},${' '}${data
            .completed_project.city && data.completed_project.city.city_name}`
        : `${data.project &&
            data.project.area &&
            data.project.area.area_name},${' '}${data.project.city &&
            data.project.city.city_name}`,
      bed: StringUtil.checkBoolean(data.is_completed_project)
        ? data.no_of_bedroom
        : data.product.number_of_bedrooms,
      bath: StringUtil.checkBoolean(data.is_completed_project)
        ? data.no_of_bathroom
        : data.product.number_of_bathrooms,
      project_url_slug: data.project && data.project.url_slug,
      is_completed_project: StringUtil.checkBoolean(data.is_completed_project),
      completed_project_name: StringUtil.checkBoolean(data.is_completed_project)
        ? data.completed_project && data.completed_project.project_name
        : null,
      metaTagSEO: {
        metaTitle: data.meta_title,
        metaDescription: data.meta_description,
        metaKeyword: data.meta_keyword,
      },
      area: data.area,
    };
  });

  return bannerData;
};

const getRentalFilters = state => {
  return state.rentals.filters;
};

const getFilteredRentals = state => {
  if (!state.rentals.rentals) {
    return null;
  }

  const activeFilters = getActiveFilters(state);
  let projects = state.rentals.rentals;
  projects = flatten(projects);

  //location filter
  if (activeFilters.location && activeFilters.location.length > 0) {
    projects = projects.filter(project => {
      return activeFilters.location.indexOf(project.cityId) > -1;
    });
  }

  //property type filter
  if (activeFilters.propertyType && activeFilters.propertyType.length > 0) {
    projects = projects.filter(project => {
      return activeFilters.propertyType.indexOf(project.propertyTypeId) > -1;
    });
  }

  //beds filter
  if (activeFilters.beds) {
    projects = projects.filter(project => {
      const maxBedrooms = project.bed;
      return maxBedrooms >= activeFilters.beds;
    });
  }

  // area filter
  if (activeFilters.area && activeFilters.area.length > 0) {
    if (activeFilters.area && activeFilters.area.length > 0) {
      const minArea = activeFilters.area[0];
      const maxArea = activeFilters.area[1];
      projects = projects.filter(project => {
        return (
          project.areaForFilter >= minArea && project.areaForFilter <= maxArea
        );
      });
    }
  }

  if (activeFilters.range && activeFilters.range.length > 0) {
    const minRange = activeFilters.range[0];
    const maxRange = activeFilters.range[1];
    projects = projects.filter(project => {
      return (
        project.priceForFilter >= minRange && project.priceForFilter <= maxRange
      );
    });
  }

  return flatten(projects);
};

const getActiveFilterNames = state => {
  return [];
};

const getActiveFilters = state => {
  return state.rentals.activeFilters;
};

const isRentalFiltered = state => {
  const activeFilters = getActiveFilters(state);
  if (!activeFilters) {
    return false;
  }

  return !!(
    activeFilters.location.length > 0 ||
    activeFilters.propertyType.length > 0 ||
    activeFilters.range.length > 0 ||
    activeFilters.area.length > 0 ||
    activeFilters.beds
  );
};

const getRentAdvertisement = state => {
  const advertData = state.rentals.adData && state.rentals.adData.homes;
  const mediaPath = state.rentals.adData && state.rentals.adData.mediaPath;

  if (advertData) {
    return {
      id: advertData.id,
      price: `${advertData.rental_price} per month`,
      rental_image: `${mediaPath.web}/${advertData.rental_image}`,
      rental_mobile_image: `${mediaPath.mobile}/${advertData.rental_mobile_image}`,
      bed: !StringUtil.checkBoolean(advertData.is_completed_project)
        ? advertData.product && advertData.product.number_of_bedrooms
        : '',
      bath: !StringUtil.checkBoolean(advertData.is_completed_project)
        ? advertData.product && advertData.product.number_of_bedrooms
        : '',
      duration: `x ${advertData.max_rent_duration} months`,
      deposit: `${advertData.deposit} for stay`,
      location: !StringUtil.checkBoolean(advertData.is_completed_project)
        ? `${advertData.project &&
            advertData.project.area &&
            advertData.project.area.area_name},${' '}${advertData.project &&
            advertData.project.city &&
            advertData.project.city.city_name}`
        : '',
      quote: advertData.quote,
    };
  }

  return [];
};

const getRecommendedList = (state, id) => {
  const rentals = flatten(state.rentals.rentals);
  const recommendedList = [];
  const filteredRentals = filter(rentals, function(n) {
    return id !== n.id;
  });

  if (filteredRentals) {
    filteredRentals.map(data => {
      const list = {
        id: data.id,
        urlSlug: data.rental_home_url_slug,
        name: data.title,
        image: data.rental_image,
        isCompletedProject: data.isCompletedProject,
        listImageUrl: data.rental_image,
        listMobileImageUrl: data.listMobileImageUrl,
        thumbNailUrl: data.thumbnail,
        location: data.location,
        city: data.city,
        postFix: data.postFix,
        projectSlug: data.projectSlug,
        productSlug: data.productSlug,
        bed: data.bed,
        bath: data.bath,
        price: data.price,
      };
      recommendedList.push(list);
    });
    return recommendedList;
  }

  return [];
};

export const RentalSelector = {
  getRentals,
  getRentalError,
  getRentalLoading,
  getRentalFeature,
  getRentalFeatureError,
  getRentalFeatureLoading,
  getRentalFilters,
  isRentalFiltered,
  getActiveFilterNames,
  getFilteredRentals,
  getActiveFilters,
  getRentalDetailBannerLoading,
  getRentalDetailBanner,
  getRentAdvertisement,
  getRecommendedList,
};
